module.exports = __webpack_public_path__ + "img/home_schoolone.04e5f300.svg";